/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.facilities.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers'
])

.controller('ResourcesFacilitiesController', ['$scope', '$uibModal', 'ApiService', 'HelpersService', function($scope, $uibModal, ApiService, HelpersService) {

    $scope.gridLink = '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ui-sref="application.resourcesInstances({ id: \'{{ row.entity.id }}\' })">{{row.getProperty(col.field)}}</a></div>';

    $scope.resourcesFacilities = {

      addModal: {},
      currentFacility: {},

      model: [],
      selected: [],

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Facilities Manager',
          buttonRight: {
            label: '+ Add Facility',
            action: function() {
              $scope.resourcesFacilities.addFacility();
            }
          }
        });
        this.getFacilities();
      },

      create: function() {
        if (this.currentFacility.hasOwnProperty('name') && this.currentFacility.name.length > 0) {
          ApiService.resource.facilities.create(this.currentFacility).then(this.success.create, this.error.create);
        }
      },

      remove: function() {
        var i, ii = this.selected.length;

        if (ii > 0) {
          for (i=0;i<ii;i++) {
            ApiService.resource.facilities.remove(this.selected[i].id).then(this.success.remove, this.error.remove);
          }
        }

      },

      hasSelected: function() {
        return (this.selected.length > 0);
      },

      hasFacilities: function() {
        return (this.model.length > 0);
      },

      getFacilities: function() {
        console.log('ResourcesFacilitiesController::getFacilities');
        ApiService.resource.facilities.list().then(this.success.getFacilities, this.error.getFacilities);
      },

      addFacility: function() {

        var self = $scope.resourcesFacilities;

        self.addModal = $uibModal.open({
          templateUrl: 'common/includes/createFacilityModal.tpl.html',
          controller: ['$scope', '$uibModalInstance', 'ValidateService', 'NoticeFactory', function ($scope, $uibModalInstance, ValidateService, NoticeFactory) {

            $scope.isSubmitted = false;

            // Populate possible values to the model for use in modal
            $scope.model = {
              name: '',
              description: '',
              capacity: null
            };

            $scope.errors = [];

            $scope.isValidName = function() {
              var r = true;
              if ($scope.isSubmitted) {
                r = ValidateService.validate([
                  { len: { value: $scope.model.name } }
                ]);
              }

              return r;
            };

            $scope.isValidCapacity = function() {
              var r = true;
              if ($scope.isSubmitted) {
                r = ValidateService.validate([
                  { greater: { less: 0, greater:  parseInt($scope.model.capacity, 10) } }
                ]);
              }
              return r;
            };

            $scope.isValidDescription = function() {
              var r = true;
              if ($scope.isSubmitted) {
                r = ValidateService.validate([
                  { len: { value: $scope.model.description } }
                ]);
              }
              return r;

            };

            $scope.hasErrors = function () {
              return ($scope.errors.length > 0);
            };

            $scope.done = function () {

              $scope.isSubmitted = true;
              if (ValidateService.validate([
                { len: { value: $scope.model.name } },
                { len: { value: $scope.model.description } },
                { greater: { less: 0, greater:  parseInt($scope.model.capacity, 10) } }
              ])) {
                $scope.success($scope.model);
              }else{
                $scope.errors = [{
                  message: 'Please correct the errors below'
                }];
              }
            };

            $scope.cancel = function () {
              $uibModalInstance.dismiss('cancel');
            };

            $scope.success = function (response) {
              $uibModalInstance.close(response);
            };

          }]
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (facility) {

          self.currentFacility = facility;
          self.create();

        }, function () {
          // Do nothing
        });
      },

      success: {
        create: function(response) {
          $scope.resourcesFacilities.currentFacility.id = response.data.payload;
          $scope.resourcesFacilities.model.push($scope.resourcesFacilities.currentFacility);
          $scope.resourcesFacilities.currentFacility = {};
        },

        getFacilities: function(response) {
          $scope.resourcesFacilities.model = response.data.payload;
        },

        remove: function(response) {
          var i, ii,
              j, jj;

          for (i=0,ii=$scope.resourcesFacilities.selected.length;i<ii;i++) {
            for (j=0,jj=$scope.resourcesFacilities.model.length;j<jj;j++) {
              if ($scope.resourcesFacilities.selected[i].id === $scope.resourcesFacilities.model[j].id) {
                $scope.resourcesFacilities.model.splice(j, 1);
              }
            }
          }

          $scope.unassignedFacilitiesGridOptions.selectAll(false);

        }
      },

      error: {
        create: function(response) {
          // TODO: Need to implement
        },

        getFacilities: function(response) {
          // TODO: Need to implement
        },

        remove: function(response) {}

      }

    };

    $scope.unassignedFacilitiesGridOptions = {
      paginate: false,
      enableRowSelection: true,
      multiselect: true,
      columnDefs: [
        {
          field: 'name',
          displayName: 'Name'
        },
        {
          field: 'description',
          displayName: 'Description'
        },
        {
          field: 'capacity',
          displayName: 'Capacity'
        }
      ]
    };

    $scope.resourcesFacilities.init();


}]);